<template>
  <ul class="nav nav-tabs nav-fill" style="">
    <li
      v-for="(t, i) in tabs"
      :key="t.key"
      v-show="t.visible == undefined || t.visible()"
      class="nav-item"
    >
      <a
        class="nav-link"
        :accesskey="i + 1"
        :class="{ active: value == t.key }"
        href="#void"
        @click.prevent="goTab(t.key)"
      >
        <span v-if="bullets" class="bullet">{{ i + 1 }}</span>
        {{ t.text }}
      </a>
    </li>
  </ul>
</template>
<script>
export default {
  props: {
    tabs: {
      type: Array,
      required: true
    },
    bullets: {
      type: Boolean,
      default: true
    },
    value: {
      type: String,
      required: true
    }
  },
  computed: {
    currentTab() {
      return this.tabs.filter(x => x.key == this.value)[0];
    },
    tabIndex() {
      return this.tabs.indexOf(this.currentTab) || 0;
    },
    nextTab() {
      for (var i = this.tabIndex + 1; i < this.tabs.length; i++) {
        var tab = this.tabs[i];
        if (tab && (tab.visible == undefined || tab.visible())) {
          return tab;
        }
      }

      return null;
    },
    prevTab() {
      for (var i = this.tabIndex - 1; i >= 0; i--) {
        var tab = this.tabs[i];
        if (tab && (tab.visible == undefined || tab.visible())) {
          return tab;
        }
      }

      return null;
    }
  },
  methods: {
    goTab(key) {
      this.$emit("input", key);
      this.$emit("change", this.currentTab);
    },
    goNextTab() {
      if (this.nextTab) {
        this.$emit("input", this.nextTab.key);
        this.$emit("change", this.currentTab);
      }
    },
    goPrevTab() {
      if (this.prevTab) {
        this.$emit("input", this.prevTab.key);
        this.$emit("change", this.currentTab);
      }
    }
  }
};
</script>
<style scoped>
.bullet {
  vertical-align: middle;
  display: inline-block;
  border-radius: 1rem;
  color: #fff;
  width: 1rem;
  height: 1rem;
  background: #35495e;
  font-size: 0.7rem;
  font-weight: bold;
  margin-top: -0.15rem;
}
</style>
